import type { SVGProps } from 'react'
const SvgSyCalendar = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			d="M3.092 8.654a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h17.824a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
			opacity={0.4}
		/>
		<path
			fillRule="evenodd"
			d="M6.808 13.31a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75m5.197-.75a.75.75 0 0 0 0 1.5h.009a.75.75 0 1 0 0-1.5zm4.437 0a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5zm0 3.886a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5zm-5.187.75a.75.75 0 0 1 .75-.75h.009a.75.75 0 1 1 0 1.5h-.01a.75.75 0 0 1-.75-.75m-3.697-.75a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5z"
			clipRule="evenodd"
			opacity={0.4}
		/>
		<g strokeLinejoin="round">
			<path d="M16.043 1.25a.75.75 0 0 0-.75.75v3.291a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V2a.75.75 0 0 0-.75-.75m-8.078 0a.75.75 0 0 0-.75.75v3.291a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V2a.75.75 0 0 0-.75-.75" />
			<path
				fillRule="evenodd"
				d="M7.771 2.828c-1.607 0-3.01.457-4.003 1.4-.993.944-1.518 2.339-1.518 3.995v9.048c0 1.678.52 3.089 1.512 4.05.99.96 2.399 1.429 4.01 1.429h8.457c1.612 0 3.016-.46 4.007-1.406s1.514-2.341 1.514-3.996V8.223c.005-1.655-.515-3.048-1.506-3.993-.99-.944-2.394-1.402-4.006-1.402zm0 1.5h8.467c1.334 0 2.315.363 2.971.988s1.045 1.553 1.041 2.905v9.127c0 1.351-.391 2.284-1.049 2.912s-1.64.99-2.972.99H7.77c-1.325 0-2.304-.368-2.964-1.008s-1.057-1.594-1.057-2.97v-9.05c0-1.35.392-2.28 1.05-2.906.66-.626 1.642-.988 2.971-.988"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyCalendar
